module.exports = __webpack_public_path__ + "img/scorecard-1.99e25697.jpg";